import React from 'react'
import { Grid } from '@mui/material'
import './loadscheddingblock.scss'

/**
 * LoadSheddingBlock Component
 * 
 * This component represents a block displaying load shedding status for a specific time interval.
 * It uses MUI's Grid system to structure the layout.
 * 
 * @component
 * @memberof Components
 * @param {Object} props - Component props.
 * @param {number} props.lightStatus - The status of the light. (0 = On, 1 = Off, other = Unknown)
 * @param {number} props.number - The hour number representing the block.
 * 
 * @example
 * return (
 *   <LoadSheddingBlock lightStatus={0} number={12} />
 * )
 */
const LoadScheddingBlock = (props) => {
    return (
        <Grid container className='blockContainer'>
            <Grid item lg={2} xs={2} className={props.lightStatus === 0 ? 'block-on' : props.lightStatus === 1 ? 'block-off' : 'block-unknown'}></Grid>
            <Grid item lg={2} xs={2} className={props.lightStatus === 0 ? 'block-on' : props.lightStatus === 1 ? 'block-off' : 'block-unknown'}></Grid>
            <Grid item lg={2} xs={2} className={props.lightStatus === 0 ? 'block-on' : props.lightStatus === 1 ? 'block-off' : 'block-unknown'}></Grid>
            <Grid item lg={2} xs={2} className={props.lightStatus === 0 ? 'block-on' : props.lightStatus === 1 ? 'block-off' : 'block-unknown'}></Grid>
            <Grid item lg={2} xs={2} className='hourNumber'>{props.number}</Grid>
            <Grid item lg={2} xs={2} className='minuteNumber'>15</Grid>
            <Grid item lg={2} xs={2} className='minuteNumber'>30</Grid>
            <Grid item lg={2} xs={2} className='minuteNumber'>45</Grid>
        </Grid>
    )
}

export default LoadScheddingBlock
